/**
 * @typedef {import('./lib/index.js').Location} Location
 */

export {location} from './lib/index.js'
